import { useContext, useEffect, useState } from "react";
import { AuthContext } from "src/contexts/AuthContext";
import { AlenProperty, Property } from "src/interfaces/IProperty";
import { AlenAccessToken } from "src/services/authService";
import { AxiosError } from "axios";
import { makeAlenAxios } from ".";
import { mapAlenPropertyToWyndProperty } from "./utils";

type FetchAlenPropertiesResponse = {
  result: AlenProperty[];
};

const fetchAlenProperties = async (alenAccess: AlenAccessToken) => {
  const alenAxios = makeAlenAxios(alenAccess);
  return alenAxios.get<FetchAlenPropertiesResponse>("/users/homes");
};

const useAlenProperties = () => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState<Property[] | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<AxiosError | undefined>();
  useEffect(() => {
    if (user?.alen) {
      fetchAlenProperties(user.alen)
        .then((response) => {
          setData(
            response.data.result.map((p) => mapAlenPropertyToWyndProperty(p))
          );
        })
        .catch((err: unknown) => {
          if (err instanceof AxiosError) {
            setError(err);
          } else {
            // eslint-disable-next-line no-console
            console.error(err);
          }
        })
        .finally(() => setIsLoading(false));
    } else {
      setData([]);
      setIsLoading(false);
    }
  }, [user]);

  return {
    data,
    isLoading,
    error,
  };
};

export default useAlenProperties;
